import { type RequestDocumentHandlerSchema } from 'modules/procurement/components/procurementTypes/Workflows/sidePanels/schemas/requestDocumentHandler'
import { HandlerFormComponentPayload } from 'modules/workflows/contexts/WorkflowContext'
import { DEFAULT_DURATION_UNIT, isValidDateUnit } from 'modules/workflows/lib/durationUnit'

import { mapEmployeeSegments } from './employeeSegmentMapper'

export const requestDocumentNodeToSchemaMapper = (
  payload: HandlerFormComponentPayload
): RequestDocumentHandlerSchema['nodeData']['payload'] => {
  const due_on_value = payload.due_on_value
  const numericDueOnValue =
    typeof due_on_value === 'number' && !isNaN(due_on_value) ? due_on_value : 2

  const due_on_unit = String(payload.due_on_unit)

  const employeeIds = Array.isArray(payload.employee_ids)
    ? payload.employee_ids.map((id) => String(id))
    : undefined

  const fallbackEmployeeIds = Array.isArray(payload.fallback_employee_ids)
    ? payload.fallback_employee_ids.map((id) => String(id))
    : undefined

  const assigneeSegments = mapEmployeeSegments(payload.employee_segments)
  const fallbackAssigneeSegments = mapEmployeeSegments(payload.fallback_employee_segments)

  return {
    title: typeof payload.title === 'string' ? payload.title : '',
    description: typeof payload.description === 'string' ? payload.description : '',
    employee_ids: employeeIds,
    employee_segments: assigneeSegments,
    fallback_employee_ids: fallbackEmployeeIds,
    fallback_employee_segments: fallbackAssigneeSegments,
    due_on_unit: isValidDateUnit(due_on_unit) ? due_on_unit : DEFAULT_DURATION_UNIT,
    due_on_value: numericDueOnValue,
  }
}
